import { FormFeedBack, ModalBase, STATUSPAGE } from '@repo/ui';
import { ChangePasswordProfileUseCaseInterface } from 'domain/usecases';
import { FormikProps } from 'formik';
import { Col, Row, Form, Input, Label } from 'reactstrap';

interface IProps {
  isOpen: boolean;
  toggleModal: () => void;
  requestChangePasswordProfile: (
    params: ChangePasswordProfileUseCaseInterface.Params,
  ) => void;
  clearModalAndClose: () => void;
  loadingModalChangePassword: STATUSPAGE;
  validationModalChangePassword: FormikProps<ChangePasswordProfileUseCaseInterface.Params>;
}

export const ModalChangePassword = ({
  isOpen,
  clearModalAndClose,
  loadingModalChangePassword,
  validationModalChangePassword,
}: IProps) => {
  return (
    <ModalBase.Wrapper
      size="md"
      isOpen={isOpen}
      toggle={clearModalAndClose}
      loading={loadingModalChangePassword === STATUSPAGE.LOADING}
    >
      <ModalBase.Header toggle={clearModalAndClose} withBorderBottom>
        Alterar senha
      </ModalBase.Header>

      <Form
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          validationModalChangePassword.handleSubmit();
          return false;
        }}
      >
        <ModalBase.Body>
          <Row className="g-3">
            <Col md={12}>
              <Label htmlFor="cpf" className="form-label">
                Senha
              </Label>
              <Input
                name="password"
                type="password"
                className="form-control"
                onBlur={validationModalChangePassword.handleBlur}
                value={validationModalChangePassword.values.password}
                onChange={validationModalChangePassword.handleChange}
                invalid={
                  !!(
                    validationModalChangePassword.touched.password &&
                    validationModalChangePassword.errors.password
                  )
                }
              />
              <FormFeedBack
                error={validationModalChangePassword.errors?.password}
                isInvalid={
                  !!(
                    validationModalChangePassword.touched.password &&
                    validationModalChangePassword.errors?.password
                  )
                }
              />
            </Col>
            <Col md={12}>
              <Label htmlFor="cpf" className="form-label mt-2">
                Confirme sua senha
              </Label>
              <Input
                type="password"
                name="confirmPassword"
                className="form-control"
                onBlur={validationModalChangePassword.handleBlur}
                onChange={validationModalChangePassword.handleChange}
                value={validationModalChangePassword.values.confirmPassword}
                invalid={
                  !!(
                    validationModalChangePassword.touched.confirmPassword &&
                    validationModalChangePassword.errors.confirmPassword
                  )
                }
              />
              <FormFeedBack
                error={validationModalChangePassword.errors?.confirmPassword}
                isInvalid={
                  !!(
                    validationModalChangePassword.touched.confirmPassword &&
                    validationModalChangePassword.errors?.confirmPassword
                  )
                }
              />
            </Col>
          </Row>
        </ModalBase.Body>
        <ModalBase.Footer>
          <ModalBase.Actions
            actionBtnType="submit"
            goBack={clearModalAndClose}
            loading={loadingModalChangePassword === STATUSPAGE.LOADING}
          />
        </ModalBase.Footer>
      </Form>
    </ModalBase.Wrapper>
  );
};
